// mui
import { makeStyles } from '@material-ui/core/styles'

// custom components
import { Text } from '../../../1elements'
import FormikField from '../../../1elements/Fields/FormikField'
import DateField from '../../../1elements/Fields/DateField'
import { placeholder } from '../../../../consts/placeholder'
import uuid from 'react-uuid'

const MultipleColumnsDataList = ({
  cardIndex,
  data,
  numberOfColumn,
  fieldIndex,
  cardLabel
}) => {
  const { label, isHidden, type, isMandatory, fieldId } = data
  const classes = useStyles({ numberOfColumn })

  //const key = `${label}${position}${cardIndex}${fieldIndex}${numberOfColumn}`
  const key = uuid()
  const fieldLoop = () => {
    const items = []

    for (let i = 0; i < numberOfColumn - 1; i++) {
      const name = `values[${cardIndex}].cardData[${fieldIndex}].fieldData[${i}]`
      const innerkey = uuid()

      const placeHolder = placeholder[type.toLowerCase()]
      if (cardLabel[i + 1].toLowerCase().match(/date/) || type === 'Date') {
        items.push(
          <DateField key={innerkey} name={name} className={classes.field} /> /// not a regular date picker, it has no independent field id
        )
      } else {
        items.push(
          <FormikField
            key={innerkey}
            name={name}
            className={classes.field}
            placeholder={placeHolder}
            errorRef={fieldId}
            type={type}
            required={isMandatory}
          />
        )
      }
    }
    return <>{items}</>
  }

  return (
    <div
      key={key}
      className={`${classes.root} ${isHidden && classes.reorderInnerDivHidden}`}
    >
      <Text>{label}</Text>
      {fieldLoop()}
    </div>
  )
}

export default MultipleColumnsDataList

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: props => `repeat(${props.numberOfColumn}, 1fr)`,
    margin: '5px 0'
  },
  cardInnerDiv: {
    margin: '0 10px 0 30px',
    width: '100%'
  },
  header: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    width: '100%'
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main
  },
  row: {
    '&:hover': {
      cursor: 'pointer',
      '& *': {
        // color: `${theme.palette.primary.accent} !important`
      }
    }
  },
  reorderInnerDivHidden: {
    '& .MuiFormControl-root': {
      opacity: 0.6
    },
    '&>*': {
      boxShadow: 'none'
    }
  },
  field: {
    width: '80%'
  }
}))
